import { render, staticRenderFns } from "./app.vue?vue&type=template&id=963d8ee4"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=963d8ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./app.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports